module.exports = __webpack_public_path__ + "img/flutter-yellow.de58665b.svg";